import React from "react";
import PropTypes from "prop-types";
import BaseBlock from "./BaseBlock";

const DEFAULT_TEXT = "No notes added for this report.";

/**
 * NotesBlock - short free-text note, rendered from an injected `binding.text`
 * prop (no fetch) - the 10th block type from the Task-0 manifest, alongside
 * exec_narrative as a props-based (non-fetching) block.
 */
const NotesBlock = ({ title = "Notes", binding }) => {
  const text = binding?.text;

  return (
    <BaseBlock title={title} isLoading={false} error={null}>
      <p className="a4-notes-text">{text || DEFAULT_TEXT}</p>
    </BaseBlock>
  );
};

NotesBlock.propTypes = {
  title: PropTypes.string,
  binding: PropTypes.shape({
    text: PropTypes.string,
  }),
};

export default NotesBlock;
